import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { headerColor, greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { lineHeight, size } from "@clockwise/web-commons/src/styles/type.styles";

const closeButton: CSSProperties = {
  position: "absolute",
  right: 0,
  top: 0,
  color: greys.slate,
};
const heading: CSSProperties = {
  fontSize: 22,
  fontWeight: "bold",
  color: headerColor,
  marginBottom: spacing.std,
  marginTop: spacing.std,
};
const subheading: CSSProperties = {
  color: greys.slate,
  marginBottom: spacing.std,
};
const primaryControls: CSSProperties = {
  marginBottom: spacing.std,
};
const billingGroupSelected: CSSProperties = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  fontSize: size.std,
};
const billingGroupOption: CSSProperties = {
  fontSize: size.std,
};
const menuItemWarning: CSSProperties = {
  color: colors.peach.darker,
  fontSize: size.md,
  lineHeight: lineHeight.std,
  display: "flex",
  alignItems: "center",
  marginTop: spacing.xs,
};
export const styles = {
  closeButton,
  heading,
  subheading,
  primaryControls,
  billingGroupSelected,
  billingGroupOption,
  menuItemWarning,
};
